module.exports = __webpack_public_path__ + "media/images/icons/en-2d19fed4fb288f7b8a8591bbe3b70429.svg";